import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateRight } from '@fortawesome/free-solid-svg-icons';
import Tooltip from './Tooltip';

const variants = {
  primary: 'ml-2 self-start mb-24',
};

const ClearButton = ({ onClick, variant, tooltipText = 'Clear selected options' }) => (
  <Tooltip text={tooltipText}>
    <FontAwesomeIcon
      icon={faRotateRight}
      className={`text-gray-500 cursor-pointer ${variants[variant]} `}
      onClick={onClick}
    />
  </Tooltip>
);

export default ClearButton;
